import { Link } from "react-router-dom";
import Header from "../components/Header";
import HeroSection from "../components/HeroSection";
import ServiceHighlights from "../components/ServiceHighlights";
import ServicesOverview from "../components/ServicesOverview";
import Footer from "../components/Footer";
import PartnerMarquee from "../components/PartnerMarquee";
import HelpButton from "../components/HelpButton";
import ActivationSteps from "../components/ActivationSteps";
import { Check, Phone } from "lucide-react";
import RenovatieFAQ from "../components/faqs/RenovatieFAQ";
import { Reviews } from "../components/Reviews";
import SEO from "../components/SEO";
import { generateServiceSchema } from "../lib/schema";

function ElektraRenovatie() {
  return (
    <div className="min-h-screen bg-gray-50 page-transition pt-[99px] md:pt-[133px]">
      <SEO
        title="Elektra renovatie - Elektraaanleggen.nl"
        description="Upgrade uw elektrische installatie naar de moderne standaard. Onze experts zorgen voor een veilige, efficiënte en toekomstbestendige oplossing voor uw woning of bedrijfspand."
        schema={generateServiceSchema({
          name: "Elektra renovatie",
          description:
            "Professionele renovatie van uw elektrische installatie voor een veiligere en meer energie-efficiënte stroomvoorziening. Onze gecertificeerde elektriciens zorgen voor een vakkundige upgrade volgens de laatste normen.",
          image: "https://elektraaanleggen.nl/images/banner.png",
        })}
      />

      <Header />
      <HeroSection
        title="Elektra renovatie"
        description="Upgrade uw elektrische installatie naar de moderne standaard. Onze experts zorgen voor een veilige en toekomstbestendige oplossing."
        imageSrc="/images/mark.png"
      />

      {/* Features Section */}
      <section className="mx-auto w-[calc(100%-2.5rem)] max-w-[1260px] mb-12 md:mb-16">
        <div className="grid items-start w-full gap-12 grid-cols-1 md:grid-cols-2 mb-16 md:mb-20 xl:mb-20">
          <div className="[&_p]:!text-[#17354A] [&_p]:text-base md:[&_p]:text-lg order-2 md:order-none">
            <h2 className="font-bold text-black leading-[1.25] text-[24px] lg:text-[36px] text-[#17354A] mb-4 md:mb-6">
              Elektra aanleggen bij renovaties – van prijsindicatie tot planning
            </h2>
            <p>
              Bij Elektra Aanleggen begrijpen we dat elke renovatie uniek is. Of
              je nu een kleine verbouwing uitvoert of een volledige
              woningrenovatie, wij zorgen ervoor dat jouw elektra veilig,
              efficiënt en volgens de nieuwste normen wordt aangelegd.
            </p>
            <br></br>
            <p className="font-semibold">
              Direct een prijsindicatie bij kleinere renovaties
            </p>
            <br></br>
            <p>
              Voor kleinere renovaties, zoals het verplaatsen van stopcontacten,
              uitbreiden van een groep of het aansluiten van een kookgroep,
              kunnen wij vaak telefonisch al een schatting geven op basis van
              jouw wensen. Stuur ons eenvoudig de details van je project, zoals
              een keukentekening of plattegrond, en wij voorzien je snel van een
              indicatieve prijs.
            </p>
            <br></br>
            <p className="font-semibold">
              Persoonlijke inspectie bij een volledige woningrenovatie
            </p>
            <br></br>
            <p>
              Gaat het om een complete woningrenovatie of een grote verbouwing?
              Dan komen wij graag persoonlijk langs voor een grondige inspectie.
              Tijdens dit bezoek:
            </p>

            <br></br>

            <ul className="space-y-3 mb-6">
              <li className="flex items-center gap-2">
                <Check className="w-5 h-5 text-[#F47B20]" />
                <span className="text-[#17354A]">
                  Kijken we samen naar jouw wensen en plannen
                </span>
              </li>
              <li className="flex items-center gap-2">
                <Check className="w-5 h-5 text-[#F47B20]" />
                <span className="text-[#17354A]">
                  Beoordelen we de huidige elektrische installatie
                </span>
              </li>
              <li className="flex items-center gap-2">
                <Check className="w-5 h-5 text-[#F47B20]" />
                <span className="text-[#17354A]">
                  Bepalen we welke aanpassingen nodig zijn
                </span>
              </li>
              <li className="flex items-center gap-2">
                <Check className="w-5 h-5 text-[#F47B20]" />
                <span className="text-[#17354A]">
                  Geven we een gedetailleerde prijsindicatie
                </span>
              </li>
              <li className="flex items-center gap-2">
                <Check className="w-5 h-5 text-[#F47B20]" />
                <span className="text-[#17354A]">
                  Stellen we een realistisch tijdsbestek op voor de uitvoering
                </span>
              </li>
            </ul>
            <br></br>
            <p>
              Met een duidelijk plan en een gestructureerde aanpak zorgen we
              ervoor dat de elektra in jouw woning volledig klaar is voor de
              toekomst.
            </p>

            <div className="h-9"></div>
            <div className="flex flex-wrap gap-3">
              <Link
                to="/offerte"
                aria-label="Vraag een vrijblijvende offerte aan voor groepenkast vervanging"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-transparent items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] bg-[#F47B20] text-white hover:bg-[#F47B20]/80 focus:bg-[#F47B20]/80 focus-visible:border-crustaLight disabled:bg-[#F47B20]/40 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">Gratis offerte</span>
              </Link>

              <a
                href="tel:+31852129778"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-[#17354A] items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] text-[#17354A] hover:bg-[#17354A] hover:text-white focus:opacity-60 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">
                  <Phone className="w-4 h-4" />
                  Bel direct 085-2129778
                </span>
              </a>
            </div>
          </div>
          <div className="order-1 md:-order-1 lg:sticky top-24">
            <div className="relative">
              <span className="absolute bg-[#17354A] text-white px-2 py-1 text-xs  rounded-md opacity-20 top-1/4 right-1/3">
                elektraaanleggen.nl
              </span>

              <img
                alt="Oude stoppenkast"
                loading="lazy"
                className="rounded-lg w-full h-auto"
                src="/images/oud-groepenkast.png"
              />
            </div>
          </div>
        </div>

        <ActivationSteps />

        <div className="grid items-center w-full gap-12 grid-cols-1 md:grid-cols-2 mb-16 md:mb-20 xl:mb-20">
          <div className="[&_p]:!text-[#17354A] [&_p]:text-base md:[&_p]:text-lg order-2 md:order-1">
            <h2 className="font-bold text-black leading-[1.25] text-[24px] lg:text-[36px] text-[#17354A] mb-4 md:mb-6">
              Is jouw elektra nog veilig?
            </h2>
            <p>
              Oude huizen ademen karakter, maar hun elektra vertelt een ander
              verhaal. Veel woningen zijn nog voorzien van verouderde
              elektrische installaties, die niet meer voldoen aan de huidige
              normen en het hoge stroomverbruik van moderne huishoudens. Dit kan
              leiden tot storingen, overbelasting, kortsluiting en zelfs
              brandgevaar. Maar hoe weet je of jouw elektra toe is aan
              vernieuwing?
            </p>
            <br></br>
            <p>
              Verouderde bedrading kan een risico vormen, vooral als er nog
              stoffen of aluminium kabels in je woning zitten. Een oude
              meterkast met smeltzekeringen is niet meer van deze tijd en biedt
              onvoldoende veiligheid. Daarnaast kan een gebrek aan
              aardlekschakelaars gevaarlijke situaties veroorzaken.
            </p>
            <br></br>
            <p>
              Moderne huishoudens gebruiken steeds meer elektrische apparaten:
              inductiekookplaten, laadpalen, warmtepompen en zonnepanelen vragen
              om een stabiele stroomvoorziening. Maar een oud systeem kan de
              belasting vaak niet meer aan. Heb je regelmatig stroomstoringen,
              flikkerende lampen of schakelaars en stopcontacten die warm
              worden? Dit zijn signalen dat je elektra niet meer betrouwbaar is.
            </p>
            <br></br>
            <p>
              Bij een keukenrenovatie, badkamerverbouwing of complete
              woningrenovatie is het essentieel om de elektrische installatie te
              laten controleren en vernieuwen. Ook als je overstapt op
              elektrisch koken of een extra groep nodig hebt voor nieuwe
              apparaten, moet je meterkast hierop worden aangepast.
            </p>
            <br></br>
            <p>
              Bij Elektra Aanleggen verzorgen wij een volledige renovatie van
              jouw elektra. Onze erkende elektriciens vervangen waar nodig de
              meterkast, groepenkast en bedrading, zodat alles weer veilig en
              toekomstbestendig is.
            </p>
            <div className="h-9"></div>
            <div className="flex flex-wrap gap-3">
              <Link
                to="/offerte"
                aria-label="Vraag een vrijblijvende offerte aan voor groepenkast vervanging"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-transparent items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] bg-[#F47B20] text-white hover:bg-[#F47B20]/80 focus:bg-[#F47B20]/80 focus-visible:border-crustaLight disabled:bg-[#F47B20]/40 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">Gratis offerte</span>
              </Link>

              <a
                href="tel:+31852129778"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-[#17354A] items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] text-[#17354A] hover:bg-[#17354A] hover:text-white focus:opacity-60 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">
                  <Phone className="w-4 h-4" />
                  Bel direct 085-2129778
                </span>
              </a>
            </div>
          </div>
          <div className="order-1 md:order-2">
            <div className="relative">
              <span className="absolute bg-[#17354A] text-white px-2 py-1 text-xs  rounded-md opacity-20 top-1/4 right-1/3">
                elektraaanleggen.nl
              </span>

              <img
                alt="Slim stroom handelen met thuisbatterij"
                loading="lazy"
                width="1028"
                height="1032"
                className="rounded-lg w-full h-auto"
                decoding="async"
                data-nimg="1"
                src="/images/renovatie-thumb.jpg"
                srcSet="/images/renovatie-thumb.jpg"
                style={{ color: "transparent" }}
              />
            </div>
          </div>
        </div>

        <div className="grid items-center w-full gap-12 grid-cols-1 md:grid-cols-2 mb-16 md:mb-20 xl:mb-20">
          <div className="[&_p]:!text-[#17354A] [&_p]:text-base md:[&_p]:text-lg order-2 md:order-none">
            <h2 className="font-bold text-black leading-[1.25] text-[24px] lg:text-[36px] text-[#17354A] mb-4 md:mb-6">
              Duurzaam renoveren: een slimme investering voor de toekomst
            </h2>
            <p>
              Bij een grote elektra-renovatie is het een uitgelezen kans om ook
              te kijken naar duurzame oplossingen. Of het nu gaat om
              wandisolatie, een hybride warmtepomp, zonnepanelen of
              energiezuinige verlichting, wij denken graag met je mee om je
              woning toekomstbestendig te maken.
            </p>
            <br></br>
            <p>
              Door de jaren heen hebben wij bij Elektra Aanleggen een sterk
              netwerk opgebouwd in verschillende vakgebieden. Hierdoor kunnen
              wij je niet alleen adviseren over de elektrische aanpassingen,
              maar ook kijken of er extra verduurzamingsmogelijkheden zijn die
              bijdragen aan een hoger energielabel en een lagere
              energierekening.
            </p>
            <br></br>
            <p>
              Een energiezuinige woning betekent niet alleen een comfortabeler
              leefklimaat, maar kan ook bijdragen aan een betere woningwaarde en
              zelfs financiële voordelen opleveren, zoals subsidies of lagere
              energiekosten. Door samen te werken met betrouwbare partners
              kunnen wij helpen een voordelig totaalpakket samen te stellen,
              zodat jij meer van je plannen kunt realiseren binnen je budget.
            </p>
            <br></br>
            <p>
              Wil je weten welke duurzame opties passen bij jouw renovatie? Neem
              dan contact met ons op voor een vrijblijvend adviesgesprek. Samen
              maken we jouw woning klaar voor de toekomst!
            </p>

            <div className="h-9"></div>
            <div className="flex flex-wrap gap-3">
              <Link
                to="/offerte"
                aria-label="Vraag een vrijblijvende offerte aan voor groepenkast vervanging"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-transparent items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] bg-[#F47B20] text-white hover:bg-[#F47B20]/80 focus:bg-[#F47B20]/80 focus-visible:border-crustaLight disabled:bg-[#F47B20]/40 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">Gratis offerte</span>
              </Link>

              <a
                href="tel:+31852129778"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-[#17354A] items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] text-[#17354A] hover:bg-[#17354A] hover:text-white focus:opacity-60 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">
                  <Phone className="w-4 h-4" />
                  Bel direct 085-2129778
                </span>
              </a>
            </div>
          </div>
          <div className="order-1 md:-order-1">
            <div className="relative">
              <span className="absolute bg-[#17354A] text-white px-2 py-1 text-xs  rounded-md opacity-20 top-1/4 right-1/3">
                elektraaanleggen.nl
              </span>
              <img
                alt="Kookgroep installatie"
                loading="lazy"
                className="rounded-lg w-full h-auto"
                src="/images/ABB-220x280-1F.webp"
              />
            </div>
          </div>
        </div>

        <div className="w-full flex justify-center">
          <div className="relative mx-auto bg-amber-100 px-5 py-3 w-full rounded-xl max-w-[1260px] lg:mb-12 lg:w-[calc(100%-2rem)] grid grid-cols-[1fr] gap-10 md:gap-12">
            <div>
              <h2 className="font-normal text-black text-md">
                Wij kunnen zorgdragen voor de verplaatsing van de groepenkast,
                zodat het nutsbedrijf de nieuwe aansluiting efficiënt en zonder
                complicaties kan realiseren.
              </h2>
            </div>
          </div>
        </div>
      </section>

      <ServicesOverview />
      <RenovatieFAQ />

      <ServiceHighlights />

      <Reviews />

      <PartnerMarquee />

      {/* CTA Section */}
      <div className="w-full cursor-pointer bg-[#2FB6D2] transition-opacity duration-150 hover:opacity-80">
        <Link
          to="/offerte"
          aria-label="Vraag een vrijblijvende offerte aan voor groepenkast vervanging"
        >
          <section className="mx-auto w-[calc(100%-2.5rem)] max-w-[1260px] text-center py-6 justify-between items-center">
            <div
              data-variant="h2"
              className="font-bold leading-[1.25] text-[28px] lg:text-[36px] self-center text-white mb-0"
            >
              Gratis offerte
            </div>
          </section>
        </Link>
      </div>

      <HelpButton />
      <Footer />
    </div>
  );
}

export default ElektraRenovatie;
